import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { StaffService } from '../staff.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  @ViewChild('f') staffSearchForm: NgForm;
  departments = [];
  designations = [];
  collectionStaffList = []
  showResult: boolean = false
  collectionStaffListPaging = [];
  Status = '';
  indexStart = 1;
  indexEnd = 10;
  pageSize = 4;
  pageNo = 1;
  totalPage = [1];
  constructor(private staffService: StaffService, public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    this.staffService.getDepartmaents().subscribe(
      (departments: any[]) => this.departments = departments,
      (error) => console.log(error)
    );
  }
  // deparment based desingation for nackend staff
  deptBasedDesignaion(data, index) {
    let dep = { departmentId: [] }
    dep.departmentId.push(data)
    this.staffService.getDesignations(dep).subscribe(
      (designations: any[]) => {
        this.designations = [];
        this.staffSearchForm.value.roleId = '';
        this.designations.push({ 'id': '', 'name': '- Please Select -' });
       // this.designations.push(designations);
        for (var i = 0; i < designations.length; i++) {         
          this.designations.push({ 'id': designations[i]['id'], 'name': designations[i]['name'] });
        }
      },
      (error) => console.log(error)
    );
  }
  onSearch() {
    console.log(this.staffSearchForm.value);
    this.collectionStaffList = []
    this.collectionStaffListPaging = [];
    this.staffService.getStaffList(this.staffSearchForm.value).subscribe(
      (staff: any[]) => {
        if (staff.length > 0) {
          this.showResult = true
          this.collectionStaffList = staff;
          if (this.collectionStaffList.length > 5) {
            let j = 1;
            for (var i = 0; i < this.collectionStaffList.length; i++) {
              i = i + this.pageSize;
              j = j + 1;
              this.totalPage.push(j);
            }
          }
          for (var i = 0; i < this.collectionStaffList.length; i++) {
            let arr = [];
            arr = this.collectionStaffList[i];
            let rowNum = i + 1;
            this.collectionStaffListPaging.push({ arr, "row": rowNum });
          }
          this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
          this.indexEnd = (this.pageNo * this.pageSize);
        } else {
          this.toastr.info('No Staff found.');
        }

      },
      (error) => console.log(error)
    );
  }

  pagingAgent(data) {
    this.pageNo = data;
    this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
    this.indexEnd = (this.pageNo) * this.pageSize;
  }

  changeItemsPerPage(data) {
    if (this.collectionStaffList.length > 0) {
      this.totalPage = [1]
      let j = 1;
      for (var i = 0; i < this.collectionStaffList.length; i++) {
        i = i + this.pageSize;
        j = j + 1;
        this.totalPage.push(j);
      }
    }
    else {
      this.totalPage = [];
    }
    this.pageSize = data;
    this.indexStart = 0;
    this.indexEnd = this.pageSize;
  }
}



// WEBPACK FOOTER //
// ./src/app/staff/search/search.component.ts